var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c(
          "div",
          [
            _c(
              "div",
              { staticClass: "flex flex_gap_10" },
              [
                _c("date-range-picker", {
                  ref: "picker",
                  attrs: {
                    startDate: _vm.startDate,
                    opens: "right",
                    ranges: _vm.ranges,
                    "locale-data": _vm.date_locale,
                  },
                  model: {
                    value: _vm.dateRange,
                    callback: function ($$v) {
                      _vm.dateRange = $$v
                    },
                    expression: "dateRange",
                  },
                }),
                _vm._v(" "),
                _c("LoadingButton", {
                  attrs: {
                    title: "Показать",
                    type: "button",
                    loading: _vm.loading,
                    color: _vm.$constants.SUCCESS_COLOR,
                    onClick: () => _vm.getStatistics(),
                    className: "btn btn-outline-success",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.activeGroup
              ? _c("StatsManagersGroups", {
                  attrs: {
                    dateRange: _vm.dateRange,
                    editGroup: _vm.activeGroup,
                    allGroups: _vm.allGroups,
                    stats: _vm.stats,
                    schedule: _vm.shifts.reduce((acc, s) => {
                      acc[s.id] = s
                      return acc
                    }, {}),
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }